import { useCallback, useEffect, useState } from 'react';

/** Keep the selected tab inside its own horizontal rail without scrolling the page. */
export function useActiveTabVisibility(value: string | undefined) {
  const [rail, setRail] = useState<HTMLDivElement | null>(null);
  const ref = useCallback((node: HTMLDivElement | null) => setRail(node), []);
  useEffect(() => {
    if (!rail) return;
    function reveal() {
      const tab = rail!.querySelector<HTMLElement>('[role="tab"][aria-selected="true"]');
      if (!tab || !rail!.clientWidth || rail!.scrollWidth <= rail!.clientWidth) return;
      const bounds = rail!.getBoundingClientRect(); const active = tab.getBoundingClientRect();
      if (active.left < bounds.left) rail!.scrollLeft += active.left - bounds.left;
      else if (active.right > bounds.right) rail!.scrollLeft += active.right - bounds.right;
    }
    reveal();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(reveal);
    observer?.observe(rail);
    window.addEventListener('resize',reveal);
    return () => { observer?.disconnect(); window.removeEventListener('resize',reveal); };
  }, [rail, value]);
  return ref;
}
